import { Observable } from "rxjs";
import { distinctUntilChanged, map, startWith } from "rxjs/operators";
import { createEventListener$ } from "./createEventListener";

// (min-width: 600px)
// (prefers-reduced-motion: reduce)
// (prefers-color-scheme: light)
// (prefers-color-scheme: dark)
export function matchMedia$(
  query = "(prefers-color-scheme: dark)"
): Observable<boolean> {
  const mediaQueryList = window.matchMedia(query);
  return createEventListener$(mediaQueryList, "change").pipe(
    map((e: MediaQueryListEvent) => e.matches),
    startWith(mediaQueryList.matches),
    distinctUntilChanged()
  );
}
